/*
 * Steps to recover the password as Array with values
 */
const forgotPasswordSteps = Object.freeze({
    sendEmail: 'send-email',
    verifyCode: 'verify-code',
    newPassword: 'new-password'
});

export default forgotPasswordSteps;
